export const sites = [
    {
        name: 'rutube',
        iframe: {
            baseSRC: 'https://rutube.ru/play/embed/',
            defaultAttributes: {
                frameBorder: '0',
                allow: 'clipboard-write; autoplay',
                webkitAllowFullScreen: true,
                mozallowfullscreen: true,
                allowFullScreen: true
            }
        },
        getSrc (url) {
            if (url.includes('embed')) return url

            const videoID = new URL(url).pathname.match(/\/(.+)\/?$/)[1]
            return this.iframe.baseSRC + videoID
        },
        srcModificate (url) {
            return url
        }
    },
    {
        name: 'vk',
        iframe: {
            baseSRC: 'https://vk.com/video_ext.php',
            defaultAttributes: {
                allow: 'autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;',
                frameborder: '0',
                allowfullscreen: true
            }
        },
        getSrc (url) {
            if (url.includes('video_ext.php')) return url

            const [oid, id] = new URL(url).pathname.match(/\/video(.+)\/?$/)[1].split('_')
            return `${this.iframe.baseSRC}?oid=${oid}&id=${id}`
        },
        srcModificate (url, { actualAttributes }) {
            return url + (actualAttributes.autoplay ? '&autoplay=1' : '')
        }
    }
]

export const sitesName = sites.map(e => e.name)
